import { Link, useNavigate } from 'react-router-dom';
import { useState, useContext } from 'react';
import { Carousel } from 'react-bootstrap';
import { Contex } from "../component/kzContex";

import { getAuth, signInWithPopup, GoogleAuthProvider, createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { useUser } from "../component/userContext";

const RegisterPage = () => {
  const { banner } = useContext(Contex);
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const navigate = useNavigate();

  const [passwordVal, setPasswordVal] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const { setUser } = useUser();
  const handleGoogleLogin = () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        setUser(result.user);
        navigate("/");
      })
      .catch((err) => {
        console.error(err);
      })
  }

  const handleGoogleRegister = (e) => {
    e.preventDefault()
    const name = e.target.name.value
    const email = e.target.email.value
    const password = e.target.password.value
    const password2 = e.target.password2.value

    if (!name || !email || !password || !password2) {
      return alert("Silahkan lengkapi Registrasi.")
    }

    // Email Validation Regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return alert("Format email tidak valid. Gunakan contoh: nama@email.com")
    }

    const domain = email.split('@')[1]?.toLowerCase();
    const blockedDomains = ['test.com', 'testing.com', 'example.com', 'fake.com'];
    if (blockedDomains.includes(domain) || !domain.includes('.')) {
      return alert("Silakan gunakan email asli yang valid (seperti @gmail.com, @yahoo.com, dll). Email testing tidak diizinkan.");
    }

    if (name.length < 4) {
      return alert("Nama harus lebih dari 4 karakter")
    } else if (name.length > 26) {
      return alert("Nama harus kurang dari 26 karakter")
    }

    if (password !== password2) {
      return alert("Password harus sama.")
    }

    // Password Complexity: min 8 chars, at least 1 number, at least 1 uppercase
    if (password.length < 8) {
      return alert("Password minimal harus 8 karakter.")
    }

    if (!/[0-9]/.test(password)) {
      return alert("Password harus mengandung minimal satu angka (0-9).")
    }

    if (!/[A-Z]/.test(password)) {
      return alert("Password harus mengandung minimal satu huruf kapital (A-Z).")
    }

    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      return alert("Password harus mengandung minimal satu karakter unik (!, %, @, #, dll).")
    }

    const auth = getAuth()
    createUserWithEmailAndPassword(auth, email, password)
      .then((result) => {
        updateProfile(result.user, {
          photoURL: '/logo.png'
        })
        setUser(result.user);
        navigate("/");
      })
      .catch((err) => {
        console.error(err);
        if (err.code === 'auth/email-already-in-use') {
          alert("Pendaftaran Gagal: Email ini sudah terdaftar. Silahkan gunakan email lain atau masuk ke akun Anda.");
        } else if (err.code === 'auth/invalid-email') {
          alert("Pendaftaran Gagal: Format email tidak valid.");
        } else if (err.code === 'auth/weak-password') {
          alert("Pendaftaran Gagal: Kata sandi terlalu lemah.");
        } else {
          alert("Pendaftaran Gagal: Terjadi kesalahan (" + err.message + ")");
        }
      })
  }

  return (
    <div className="container" id="registerpage">
      <section className="pt-3 pb-5 mt-4">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-lg-12 col-xl-11">
              <div className="text-black">
                <div className="p-md-5 p-lg-5">
                  <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">

                      <h1 className="text-center fw-bold mb-2 mx-1 mx-md-4 mt-4">Daftar</h1>
                      <p className="text-center mb-4 mx-1 mx-md-4 mt-2">Nikmati berbagai Manfaat dengan Mendaftar!</p>
                      <form className="mx-1 mx-md-4 mt-1" autoComplete='off' onSubmit={handleGoogleRegister}>

                        <div className="d-flex flex-row align-items-center mb-3">
                          <i className="fas fa-user fa-lg me-3 fa-fw"></i>
                          <div className="form-outline flex-fill mb-0">
                            <label className="form-label" htmlFor="name">Nama</label>
                            <input type="text" id="name" className="form-control" required />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3">
                          <i className="fas fa-envelope fa-lg me-3 fa-fw"></i>
                          <div className="form-outline flex-fill mb-0">
                            <label className="form-label" htmlFor="email">Email</label>
                            <input type="email" id="email" className="form-control" required />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-start mb-3">
                          <i className="fas fa-lock fa-lg me-3 fa-fw" style={{ marginTop: '40px' }}></i>
                          <div className="form-outline flex-fill mb-0">
                            <label className="form-label" htmlFor="password">Password</label>
                            <div className="position-relative">
                              <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                className="form-control"
                                value={passwordVal}
                                onChange={(e) => setPasswordVal(e.target.value)}
                                required
                              />
                              <i
                                className={`bi ${showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'} position-absolute top-50 end-0 translate-middle-y me-3`}
                                style={{ cursor: 'pointer', color: 'var(--textSecondary)' }}
                                onClick={() => setShowPassword(!showPassword)}
                              ></i>
                            </div>
                            <div className="mt-3 text-start bg-secondary bg-opacity-10 p-3 rounded">
                              <div className="small fw-bold mb-2">Syarat Kata Sandi:</div>
                              <div className="d-flex flex-column gap-1 small">
                                <span className={/[A-Z]/.test(passwordVal) && /[a-z]/.test(passwordVal) ? 'text-success' : 'text-danger'}>
                                  <i className={`bi ${/[A-Z]/.test(passwordVal) && /[a-z]/.test(passwordVal) ? 'bi-check-circle-fill' : 'bi-x-circle'} me-2`}></i>
                                  Huruf besar & kecil (A, z)
                                </span>
                                <span className={/[0-9]/.test(passwordVal) ? 'text-success' : 'text-danger'}>
                                  <i className={`bi ${/[0-9]/.test(passwordVal) ? 'bi-check-circle-fill' : 'bi-x-circle'} me-2`}></i>
                                  Angka (0-9)
                                </span>
                                <span className={/[!@#$%^&*(),.?":{}|<>]/.test(passwordVal) ? 'text-success' : 'text-danger'}>
                                  <i className={`bi ${/[!@#$%^&*(),.?":{}|<>]/.test(passwordVal) ? 'bi-check-circle-fill' : 'bi-x-circle'} me-2`}></i>
                                  Karakter unik (!, %, @, #, dll)
                                </span>
                                <span className={passwordVal.length >= 8 ? 'text-success' : 'text-danger'}>
                                  <i className={`bi ${passwordVal.length >= 8 ? 'bi-check-circle-fill' : 'bi-x-circle'} me-2`}></i>
                                  Minimal 8 karakter
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3">
                          <i className="fas fa-key fa-lg me-3 fa-fw"></i>
                          <div className="form-outline flex-fill mb-0">
                            <label className="form-label" htmlFor="password2">Repeat your password</label>
                            <div className="position-relative">
                              <input type={showPassword ? "text" : "password"} id="password2" className="form-control" required />
                              <i
                                className={`bi ${showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'} position-absolute top-50 end-0 translate-middle-y me-3`}
                                style={{ cursor: 'pointer', color: 'var(--textSecondary)' }}
                                onClick={() => setShowPassword(!showPassword)}
                              ></i>
                            </div>
                          </div>
                        </div>

                        <div className="form-check d-flex justify-content-center mb-3 mx-3">
                          <input className="form-check-input me-2" type="checkbox" value="" id="form2Example3c" required />
                          <label className="form-check-label" htmlFor="form2Example3">
                            I agree all statements in <Link to='/termscondition' className="termservice">Terms &amp; Conditions</Link>
                          </label>
                        </div>

                        <div className="justify-content-center mx-3">
                          <button type='submit' className="registerbtn btn btn-primary btn-lg w-100">Daftar</button>
                          <button
                            className="signup-google btn btn-primary btn-lg w-100 mt-2"
                            type='button'
                            onClick={handleGoogleLogin}
                          >
                            <i className="bi bi-google"></i>
                            Daftar dengan Google
                          </button>
                        </div>

                        <div className="text-center">
                          <span className="d-inline">
                            Sudah punya akun?
                            <Link to='/login' className='d-inline text-decoration-none"'>
                              Masuk Sekarang
                            </Link>
                          </span>
                        </div>

                      </form>

                    </div>
                    <div className="bannerslider col-md-10 col-lg-6 col-xl-7 mt-lg-1 order-1 order-lg-2 d-flex align-items-center">
                      <Carousel fade activeIndex={index} onSelect={handleSelect} indicators={false}>
                        {banner && banner.length > 0 ? (
                          banner.map((b, i) => (
                            <Carousel.Item key={i}>
                              <img className="d-block w-100" src={b.image} alt={`Slide ${i}`} />
                            </Carousel.Item>
                          ))
                        ) : (
                          <Carousel.Item>
                            <div className="d-block w-100 bg-secondary" style={{ height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <span className="text-white">Loading Banners...</span>
                            </div>
                          </Carousel.Item>
                        )}
                      </Carousel>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default RegisterPage;
